(function () {
  var modal       = document.getElementById('CustomZoomModal');
  var main        = document.getElementById('CzmMain');
  var img         = document.getElementById('CzmImage');
  var videoWrap   = document.getElementById('CzmVideoWrap');
  var videoPosterBtn = document.getElementById('CzmVideoPosterBtn');
  var videoPoster = document.getElementById('CzmVideoPoster');
  var video       = document.getElementById('CzmVideo');
  var closeBtn    = document.getElementById('CzmClose');
  var zoomBtn     = document.getElementById('CzmZoom');
  var thumbsContainer = document.getElementById('CzmThumbs');
  var media       = window.__czmMedia || [];
  var featuredId  = window.__czmFeaturedId;

  (function reorderMediaAndThumbs() {
    return; // Disabled — custom-zoom-modal.liquid now builds media + thumbs in the correct order
            // (featured image → first video → rest in position order), matching the main gallery.
    var videos = [];
    var images = [];
    var firstVideo = null;
    var firstVideoThumb = null;

    media.forEach(function (item, index) {
      var thumb = document.querySelectorAll('.czm__thumb')[index];
      if (item.type === 'video' || item.type === 'external_video') {
        if (!firstVideo) {
          firstVideo = item;
          firstVideoThumb = thumb;
        } else {
          videos.push({ media: item, thumb: thumb });
        }
      } else {
        images.push({media: item, thumb: thumb});
      }
    });

    if (!firstVideo) return;

    var newMedia = [];
    var newThumbs = [];

    if (images.length > 0) {
      var firstImg = images.shift();
      newMedia.push(firstImg.media);
      newThumbs.push(firstImg.thumb);
    } else {
      newMedia.push(firstVideo);
      newThumbs.push(firstVideoThumb);
      firstVideo = null;
    }

    if (firstVideo) {
      newMedia.push(firstVideo);
      newThumbs.push(firstVideoThumb);
    }

    images.forEach(function (img) {
      newMedia.push(img.media);
      newThumbs.push(img.thumb);
    });

    videos.forEach(function (vid) {
      newMedia.push(vid.media);
      newThumbs.push(vid.thumb);
    });

    media = newMedia;

    if (thumbsContainer) {
      thumbsContainer.innerHTML = '';
      newThumbs.forEach(function (thumb) {
        if (thumb) thumbsContainer.appendChild(thumb);
      });
    }
  })();

  var featuredIdx = 0;
  for (var _fi = 0; _fi < media.length; _fi++) {
    if (String(media[_fi].id) === String(featuredId)) { 
      featuredIdx = _fi; 
      break; 
    }
  }

  var ZOOM_STEPS  = [1, 2, 4];
  var zoomStep    = 0;
  var idx         = 0;
  var isZoomed    = false;
  var isVideo     = false;
  var cache       = {};

  var mTx = 0, mTy = 0;
  var dragActive = false, dragLastX = 0, dragLastY = 0, dragMoved = false;
  var lastTap = 0;
  var swipeStartX = 0, swipeStartY = 0, swipeActive = false;
  var pinchActive = false, pinchStartDist = 0, pinchStartScale = 1;
  var currentMobileScale = 1;

  function isMobile() { return window.innerWidth < 750; }

  function preload(i) {
    if (!media[i] || cache[i] || media[i].type !== 'image') return;
    var p = new Image();
    p.onload = function () { cache[i] = p; };
    p.src = media[i].src;
  }

  var tooltipInterval = null;

  function startTooltipPulse() {
    stopTooltipPulse();
    var label = zoomBtn && zoomBtn.querySelector('.czm__zoom-label');
    if (!label) return;
    function pulse() {
      if (isVideo) return;
      label.classList.add('is-visible');
      setTimeout(function () { label.classList.remove('is-visible'); }, 2500);
    }
    pulse();
    tooltipInterval = setInterval(pulse, 6500);
  }

  function stopTooltipPulse() {
    if (tooltipInterval) { clearInterval(tooltipInterval); tooltipInterval = null; }
    var label = zoomBtn && zoomBtn.querySelector('.czm__zoom-label');
    if (label) label.classList.remove('is-visible');
  }

  function stopVideo() {
    if (video) {
      video.pause();
      if (video._tzHls) { try { video._tzHls.destroy(); } catch (e) {} video._tzHls = null; }
      video.src = '';
      video.style.display = 'none';
    }
    if (videoPosterBtn) videoPosterBtn.style.display = 'flex';
  }

  function open(i) {
    idx = i;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    load(i);
    setThumb(i);
    preload(i - 1);
    preload(i + 1);
    closeBtn.focus();
    startTooltipPulse();
  }

  function close() {
    stopTooltipPulse();
    stopVideo();
    if (modal.contains(document.activeElement)) document.activeElement.blur();
    modal.classList.remove('is-open', 'czm--zoomed');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetZoom();
  }

  function load(i) {
    var m = media[i];
    if (!m) return;

    stopVideo();
    resetZoom();

    isVideo = m.type === 'video' || m.type === 'external_video';

    if (isVideo) {
      img.style.display            = 'none';
      img.setAttribute('aria-hidden', 'true');
      videoWrap.style.display      = 'flex';
      videoWrap.setAttribute('aria-hidden', 'false');
      videoPoster.src              = m.poster;
      videoPoster.alt              = m.alt || '';
      videoPosterBtn.style.display = 'flex';
      video.style.display          = 'none';
      video.src                    = '';
      videoWrap.__videoSrc         = m.videoSrc;
      zoomBtn.style.display        = 'none';
      main.style.cursor            = 'default';
      // Auto-play on open (the modal was opened by a user click, so autoplay is allowed).
      if (m.videoSrc) playSrc(m.videoSrc);
    } else {
      videoWrap.style.display = 'none';
      videoWrap.setAttribute('aria-hidden', 'true');
      img.style.display       = 'block';
      img.setAttribute('aria-hidden', 'false');
      zoomBtn.style.display   = 'flex';
      main.style.cursor       = 'zoom-in';

      img.onload = null;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');

      img.alt = m.alt || '';

      if (cache[i]) {
        img.src = cache[i].src;
        sizeImageAfterLoad();
      } else {
        img.src = m.src;
        (function (loadIdx, loadSrc) {
          img.onload = function () {
            if (img.src !== loadSrc) return;
            cache[loadIdx] = { src: loadSrc };
            sizeImageAfterLoad();
          };
          if (img.complete && img.naturalWidth > 0) {
            sizeImageAfterLoad();
          }
        }(i, m.src));
      }
    }
    updateZoomBtn();
    if (isVideo) stopTooltipPulse();
    else startTooltipPulse();
  }

  function sizeImageAfterLoad() {
    if (img.decode) {
      img.decode().then(function () {
        requestAnimationFrame(sizeImage);
        requestAnimationFrame(sizeImage);
      }).catch(function () {
        requestAnimationFrame(sizeImage);
      });
    } else {
      requestAnimationFrame(sizeImage);
      setTimeout(sizeImage, 32);
    }
  }

  function sizeImage() {
    var cW = main.clientWidth;
    var cH = main.clientHeight;
    if (!img.naturalWidth || cW === 0 || cH === 0) return;

    var r  = img.naturalWidth / img.naturalHeight;
    var cr = cW / cH;
    var w, h;

    if (r > cr) { w = cW; h = w / r; }
    else        { h = cH; w = h * r; }

    img.style.width     = w + 'px';
    img.style.height    = h + 'px';
    img.style.left      = ((cW - w) / 2) + 'px';
    img.style.top       = ((cH - h) / 2) + 'px';
    img.style.transform = '';

    mTx = 0; mTy = 0;
    currentMobileScale = 1;
  }

  function setThumb(i) {
    var currentThumbs = document.querySelectorAll('.czm__thumb');
    currentThumbs.forEach(function (t, j) {
      var active = j === i;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var activeThumb = document.querySelectorAll('.czm__thumb')[i];
    if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  function resetZoom() {
    isZoomed  = false;
    zoomStep  = 0;
    mTx = 0; mTy = 0;
    currentMobileScale = 1;
    img.style.transition = 'none';
    img.style.transform  = '';
    void img.offsetWidth;
    img.style.transition = '';
    modal.classList.remove('czm--zoomed');
    if (!isVideo) main.style.cursor = 'zoom-in';
    updateZoomBtn();
  }

  function clampAndApply(scale) {
    var s  = scale || currentMobileScale;
    var cW = main.clientWidth;
    var cH = main.clientHeight;
    var iW = parseFloat(img.style.width)  || cW;
    var iH = parseFloat(img.style.height) || cH;
    var maxX = Math.max(0, (iW * s - cW) / 2);
    var maxY = Math.max(0, (iH * s - cH) / 2);
    mTx = Math.max(-maxX, Math.min(maxX, mTx));
    mTy = Math.max(-maxY, Math.min(maxY, mTy));
    img.style.transform = 'translate(' + mTx + 'px,' + mTy + 'px) scale(' + s + ')';
  }

  function updateZoomBtn() {
    if (!zoomBtn) return;
    var label   = zoomBtn.querySelector('.czm__zoom-label');
    var zoomIn  = zoomBtn.querySelector('.czm__zoom-in');
    var zoomOut = zoomBtn.querySelector('.czm__zoom-out');
    var curScale = isMobile() ? currentMobileScale : ZOOM_STEPS[zoomStep];
    var nextStep = (zoomStep + 1) % ZOOM_STEPS.length;
    var nextScale = ZOOM_STEPS[nextStep];

    if (curScale > 1) {
      if (zoomStep === ZOOM_STEPS.length - 1) {
        if (zoomIn)  zoomIn.style.display  = 'none';
        if (zoomOut) zoomOut.style.display = 'block';
        if (label)   label.textContent     = 'Click to zoom out (1×)';
        zoomBtn.setAttribute('aria-label', 'Click to zoom out to 1×');
      } else {
        if (zoomIn)  zoomIn.style.display  = 'block';
        if (zoomOut) zoomOut.style.display = 'none';
        if (label)   label.textContent     = 'Click for ' + nextScale + '× zoom';
        zoomBtn.setAttribute('aria-label', 'Click for ' + nextScale + '× zoom');
      }
    } else {
      if (zoomIn)  zoomIn.style.display  = 'block';
      if (zoomOut) zoomOut.style.display = 'none';
      if (label)   label.textContent     = 'Click for 2× zoom';
      zoomBtn.setAttribute('aria-label', 'Zoom in — click for 2× zoom');
    }
  }

  function toggleDesktopZoom(originX, originY) {
    if (isVideo) return;
    zoomStep = (zoomStep + 1) % ZOOM_STEPS.length;
    var scale = ZOOM_STEPS[zoomStep];
    img.style.transition = 'transform 0.22s ease';

    if (scale === 1) {
      isZoomed = false;
      mTx = 0; mTy = 0;
      img.style.transform = '';
      modal.classList.remove('czm--zoomed');
      main.style.cursor = 'zoom-in';
    } else {
      isZoomed = true;
      modal.classList.add('czm--zoomed');
      main.style.cursor = 'grab';

      if (originX != null && originY != null) {
        var r  = main.getBoundingClientRect();
        var iW = parseFloat(img.style.width)  || main.clientWidth;
        var iH = parseFloat(img.style.height) || main.clientHeight;
        var rx = (originX - r.left) / r.width;
        var ry = (originY - r.top)  / r.height;
        mTx = (0.5 - rx) * iW * (scale - 1);
        mTy = (0.5 - ry) * iH * (scale - 1);
      }
      clampAndApplyDesktop(scale);
    }
    updateZoomBtn();
    setTimeout(function () { img.style.transition = ''; }, 230);
  }

  function clampAndApplyDesktop(scale) {
    var s   = scale || ZOOM_STEPS[zoomStep];
    var cW  = main.clientWidth;
    var cH  = main.clientHeight;
    var iW  = parseFloat(img.style.width)  || cW;
    var iH  = parseFloat(img.style.height) || cH;
    var maxX = Math.max(0, (iW * s - cW) / 2);
    var maxY = Math.max(0, (iH * s - cH) / 2);
    mTx = Math.max(-maxX, Math.min(maxX, mTx));
    mTy = Math.max(-maxY, Math.min(maxY, mTy));
    img.style.transform = 'translate(' + mTx + 'px,' + mTy + 'px) scale(' + s + ')';
  }

  function toggleMobileZoom() {
    if (isVideo) return;
    img.style.transition = 'transform 0.25s ease';
    zoomStep = (zoomStep + 1) % ZOOM_STEPS.length;
    currentMobileScale = ZOOM_STEPS[zoomStep];

    if (currentMobileScale === 1) {
      mTx = 0; mTy = 0;
      img.style.transform = '';
      modal.classList.remove('czm--zoomed');
      main.style.cursor = 'zoom-in';
    } else {
      clampAndApply();
      modal.classList.add('czm--zoomed');
      main.style.cursor = 'grab';
    }
    updateZoomBtn();
    setTimeout(function () { img.style.transition = ''; }, 260);
  }

  main.addEventListener('click', function (e) {
    if (isMobile() || isVideo) return;
    if (e.target === zoomBtn || zoomBtn.contains(e.target)) return;
    if (e.target === closeBtn || closeBtn.contains(e.target)) return;
    toggleDesktopZoom(e.clientX, e.clientY);
  });

  main.addEventListener('mousemove', function (e) {
    if (isMobile() || isVideo || !isZoomed) return;
    var s  = ZOOM_STEPS[zoomStep];
    var r  = main.getBoundingClientRect();
    var iW = parseFloat(img.style.width)  || main.clientWidth;
    var iH = parseFloat(img.style.height) || main.clientHeight;
    var rx = (e.clientX - r.left) / r.width;
    var ry = (e.clientY - r.top)  / r.height;
    mTx = (0.5 - rx) * iW * (s - 1);
    mTy = (0.5 - ry) * iH * (s - 1);
    clampAndApplyDesktop(s);
  });

  main.addEventListener('mousedown', function (e) {
    if (isMobile() || isVideo || !isZoomed) return;
    dragActive = true;
    dragLastX  = e.clientX;
    dragLastY  = e.clientY;
    dragMoved  = false;
    main.style.cursor = 'grabbing';
    e.preventDefault();
  });

  document.addEventListener('mousemove', function (e) {
    if (!dragActive || isMobile()) return;
    var dx = e.clientX - dragLastX;
    var dy = e.clientY - dragLastY;
    dragLastX = e.clientX;
    dragLastY = e.clientY;
    if (Math.abs(dx) > 1 || Math.abs(dy) > 1) dragMoved = true;
    mTx += dx;
    mTy += dy;
    clampAndApplyDesktop();
  });

  document.addEventListener('mouseup', function () {
    if (!dragActive) return;
    dragActive = false;
    if (!isMobile() && isZoomed) main.style.cursor = 'grab';
  });

  main.addEventListener('touchstart', function (e) {
    if (!isMobile()) return;
    if (e.touches.length === 2) {
      pinchActive    = true;
      swipeActive    = false;
      pinchStartDist = getTouchDist(e.touches);
      pinchStartScale= currentMobileScale;
      e.preventDefault();
      return;
    }
    if (e.touches.length !== 1) return;
    dragActive  = true;
    dragMoved   = false;
    swipeActive = true;
    dragLastX   = e.touches[0].clientX;
    dragLastY   = e.touches[0].clientY;
    swipeStartX = e.touches[0].clientX;
    swipeStartY = e.touches[0].clientY;
  }, { passive: false });

  main.addEventListener('touchmove', function (e) {
    if (!isMobile()) return;

    if (e.touches.length === 2 && pinchActive) {
      var dist  = getTouchDist(e.touches);
      var ratio = dist / pinchStartDist;
      currentMobileScale = Math.max(1, Math.min(4, pinchStartScale * ratio));
      if (currentMobileScale > 1) {
        modal.classList.add('czm--zoomed');
        main.style.cursor = 'grab';
      }
      clampAndApply();
      updateZoomBtn();
      e.preventDefault();
      return;
    }

    if (!dragActive || e.touches.length !== 1) return;

    var dx = e.touches[0].clientX - dragLastX;
    var dy = e.touches[0].clientY - dragLastY;
    dragLastX = e.touches[0].clientX;
    dragLastY = e.touches[0].clientY;

    if (currentMobileScale > 1) {
      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) dragMoved = true;
      mTx += dx;
      mTy += dy;
      clampAndApply();
      e.preventDefault();
    }
  }, { passive: false });

  main.addEventListener('touchend', function (e) {
    if (!isMobile()) return;

    if (pinchActive) {
      pinchActive = false;
      if (currentMobileScale <= 1) {
        currentMobileScale = 1; mTx = 0; mTy = 0;
        img.style.transform = '';
        modal.classList.remove('czm--zoomed');
        main.style.cursor = 'zoom-in';
        updateZoomBtn();
      }
      return;
    }

    if (!dragActive) return;
    dragActive = false;

    if (dragMoved) return;

    if (swipeActive) {
      var totalDx = e.changedTouches[0].clientX - swipeStartX;
      var totalDy = e.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(totalDx) > 40 && Math.abs(totalDx) > Math.abs(totalDy)) {
        if (totalDx < 0) open((idx + 1) % media.length);
        else             open((idx - 1 + media.length) % media.length);
        return;
      }
    }

    var now = Date.now();
    if (now - lastTap < 300) {
      lastTap = 0;
      toggleMobileZoom();
    } else {
      lastTap = now;
    }
  });

  function getTouchDist(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  if (zoomBtn) {
    zoomBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isMobile()) toggleMobileZoom();
      else            toggleDesktopZoom();
    });
  }

  // ── HLS support (Bunny videos are .m3u8) ──
  var NATIVE_HLS = video && video.canPlayType('application/vnd.apple.mpegurl') !== '';
  var hlsLoading = null;
  function ensureHls() {
    if (window.Hls) return Promise.resolve(true);
    if (!window.__tzHlsSrc) return Promise.resolve(false);
    if (hlsLoading) return hlsLoading;
    hlsLoading = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = window.__tzHlsSrc; s.async = true;
      s.onload = function () { resolve(!!window.Hls); };
      s.onerror = function () { resolve(false); };
      document.head.appendChild(s);
    });
    return hlsLoading;
  }
  function playSrc(src) {
    videoPosterBtn.style.display = 'none';
    video.style.display = 'block';
    var isHls = /\.m3u8(\?|$)/i.test(src);
    if (!isHls || NATIVE_HLS) { video.src = src; video.play(); return; }
    ensureHls().then(function (ok) {
      if (ok && window.Hls && window.Hls.isSupported()) {
        if (video._tzHls) { try { video._tzHls.destroy(); } catch (e) {} }
        var hls = new window.Hls({ capLevelToPlayerSize: true });
        hls.loadSource(src);
        hls.attachMedia(video);
        video._tzHls = hls;
        hls.on(window.Hls.Events.MANIFEST_PARSED, function () { video.play(); });
      } else { video.src = src; video.play(); }
    });
  }

  if (videoPosterBtn) {
    videoPosterBtn.addEventListener('click', function () {
      var src = videoWrap.__videoSrc;
      if (!src) return;
      playSrc(src);
    });
  }

  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    close();
  });

  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); open((idx + 1) % media.length); }
    if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   { e.preventDefault(); open((idx - 1 + media.length) % media.length); }
  });

  document.querySelectorAll('.czm__thumb').forEach(function (t, i) {
    t.addEventListener('mouseenter', function () { preload(i); });
    t.addEventListener('click', function () { open(i); });
  });

  document.addEventListener('click', function (e) {
    if (modal.classList.contains('is-open')) return;

    var trigger = e.target.closest('.product__media-item, [data-media-id], .product__thumbnail');
    if (!trigger) return;

    var mediaIdEl = trigger.dataset.mediaId ? trigger : trigger.closest('[data-media-id]');
    var mediaId = mediaIdEl ? mediaIdEl.dataset.mediaId : null;

    var targetIdx = featuredIdx;

    if (mediaId) {
      var fi = media.findIndex(function (m) { return String(m.id) === String(mediaId); });
      if (fi >= 0) targetIdx = fi;
    }

    e.preventDefault();
    e.stopPropagation();
    open(targetIdx);
  }, true);

  window.addEventListener('resize', function () {
    if (modal.classList.contains('is-open') && !isVideo) {
      requestAnimationFrame(sizeImage);
    }
  });
})();